var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2",attrs:{"icon":"","title":"Download data to Excel","loading":_vm.isLoading},on:{"click":_vm.download}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiDatabaseExport))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }